import SidePanelSection from "components/elements/SidePanel/SidePanelSection";
import { PropsWithChildren } from "react";

export default function SidePanelHeader(p: PropsWithChildren<{}>) {
  return (
    <SidePanelSection>
      <div className="border-b bg-white pb-4 pt-6">{p.children}</div>
    </SidePanelSection>
  );
}
